import React from 'react'

type FlowTargetProviderType = {
  target: string
  setTarget: (target: string) => void
}

const FlowTargetContext = React.createContext(null)

const FlowTargetProvider = ({ children }) => {
  const [target, _setTarget] = React.useState('')
  const timerRef = React.useRef(null)

  const setTarget: FlowTargetProviderType['setTarget'] = React.useCallback(
    target => {
      const stage = document.getElementById(`flow-${target}`)
      if (!stage) {
        return
      }

      stage.scrollIntoView({ behavior: 'smooth' })

      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
      _setTarget(target)
      timerRef.current = setTimeout(() => _setTarget(''), 5000)
    },
    []
  )

  return (
    <FlowTargetContext.Provider value={{ target, setTarget }}>
      {children}
    </FlowTargetContext.Provider>
  )
}

export default FlowTargetProvider

export const useFlowTarget = () =>
  React.useContext(FlowTargetContext) as FlowTargetProviderType
